$(function () {
    if ($('.checkout-payment').length > 0) {
        setProceed();
    }
    $('.gateway').on('click', setGateway);
    $('#issuers').on('change', setGateway)
    $('#alt-gateways').on('change', setGateway)

    $('.delivery-choice').on('click', setDelivery)
    $('#conditions').on('change', setProceed);
    localStorage.removeItem('orderPath')

});


function setProceed(){
    let gateway = $('.gateway-choice:checked').val();
    let issuer = $('#issuers').val();
    let conditions = $('#conditions').prop('checked');
    if(gateway === 'other'){
        gateway = $('#alt-gateways').find(":selected").val();
    }
    $('#realgateway').val(gateway);
    let error = false;
    $('.btn-pay').prop("disabled", false);
    $('#gateway-IDEAL').removeClass('error');
    if(!gateway) {
        error = true;
    }
    else if (gateway == 'IDEAL' && issuer == 'none') {
        error = true;
        $('#gateway-IDEAL').addClass('error');
    }
    $('#conditions').removeClass('error');
    if(!error && !conditions) {
        $('#conditions').addClass('error');
    }
    if(error || !conditions) {
        $('.btn-pay').prop("disabled", true);
    }
}


function setGateway(e) {
    e.preventDefault();
    e.stopPropagation();
    let $choice = $(this).find('.gateway-choice');
    $choice.prop('checked', true);
    setProceed();
}

function setDelivery(e) {
    $('#delivery-form').submit();
}
